module.exports = __webpack_public_path__ + "img/personal-area.efa66007.svg";